export const users = [
  {
    id: 1,
    firstName: 'Andy',
    lastName: 'Spoone',
    email: 'aspoone@sierralabs.com',
    teamIds: [4, 3]
  },
  {
    id: 2,
    firstName: 'Ashoi',
    lastName: 'Patel',
    email: 'apatel@sierralabs.com',
    teamIds: [3]
  },
  {
    id: 3,
    firstName: 'Alex',
    lastName: 'Castaneda',
    email: 'acastaneda@sierralabs.com',
    teamIds: [1]
  },
  {
    id: 4,
    firstName: 'Ryan',
    lastName: 'Evans',
    email: 'revans@sierralabs.com',
    teamIds: [2]
  },
  {
    id: 5,
    firstName: 'Ryan',
    lastName: 'Yoshioka',
    email: 'ryoshioka@sierralabs.com',
    teamIds: [1]
  },
  {
    id: 6,
    firstName: 'Steve',
    lastName: 'Sigler',
    email: 'ssigler@sierralabs.com',
    teamIds: [1]
  },
  {
    id: 7,
    firstName: 'Kelly',
    lastName: 'Chu',
    email: 'kchu@sierralabs.com',
    teamIds: [2, 4]
  },
  {
    id: 8,
    firstName: 'Sundar',
    lastName: 'Selvatharasu',
    email: 'sundar@sierralabs.com',
    teamIds: [4, 5]
  },
  {
    id: 9,
    firstName: 'Charton',
    lastName: 'Sapinoso',
    email: 'csapinoso@sierralabs.com',
    teamIds: [4, 5]
  }
];
